import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';

/** Preserve query string when moving /tenant/roadmaps/planning → /tenant/planning */
export const PlanningLegacyRedirect: React.FC = () => {
  const location = useLocation();
  return <Navigate to={`/tenant/planning${location.search}${location.hash}`} replace />;
};
